import { useCallback, useState } from "react";
const useDebounce = (delay = 500, defaultValue = '')=>{
    const [debounceValue, setDebounceValue] = useState(defaultValue);
    const changeHandler = (value)=>setDebounceValue(value);
    const debouncedChangeHandler = useCallback((value)=>{
        let timeoutId;
        console.log(value);
        return (event)=>{
            clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>{
                changeHandler(event.target.value);
            }, delay);
        };
    }, [
        delay
    ]);
    const handleChange = (event)=>{
        debouncedChangeHandler(event.target.value)(event);
    };
    const handleStringChange = (event)=>{
        debouncedChangeHandler(event)({
            target: {
                value: event
            }
        });
    };
    return {
        debounceValue,
        handleChange,
        handleStringChange
    };
};
export { useDebounce };
